import React, { useContext, useEffect, useState } from "react";
import { Modal, Form } from "react-bootstrap";
import {
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  TextField,
} from "@mui/material";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { requestAxios, ComboBox } from "../../../../util/util";
import AppContext from "../../../../Context/AppContext";
import "./ModalAdicion.css";

const ModalAdicion = ({
  show,
  setShow,
  setCurrentRow,
  currentRow,
  acreditadoInfo,
}) => {
  const { checkUserSession, changeLoading } = useContext(AppContext);
  const [cmbPaises, setCmbPaises] = useState([]);
  const [cmbEstados, setCmbEstados] = useState([]);
  const [validated, setValidated] = useState(false);
  const infoUs = checkUserSession();

  useEffect(() => {
    loadInfo();
  }, []);
  async function loadInfo() {
    var listPais = await ComboBox.cmbPaises(infoUs);
    var listEstados = await ComboBox.cmbEstados(infoUs, 25);
    setCmbPaises(listPais);
    setCmbEstados(listEstados);
  }

  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      dialogClassName="modal-90wDirecciones"
      aria-labelledby="example-custom-modal-styling-title"
    >
      <Modal.Header closeButton>
        <Modal.Title
          id="AcreditadoDetalleModalTitle"
          className="ModalDomiciliosModalTitle"
        >
          Agregar: <span>Nuevo Dato de Contacto</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form noValidate className="modalAdicionDireccion__FullBody">
          <div className="modalAdicionDireccion__bodycontainer2">
            <TextField
              id="outlined-basic"
              label="Nombre Referencia  Familiar"
              variant="outlined"
              className="txtDireccionCalle"
              value={currentRow["NombreRef"]}
            />
            <TextField
              id="outlined-basic"
              label="Dirección Ref. Fam."
              variant="outlined"
              className="txtDireccionCalle"
              value={currentRow["DireccRef"]}
            />
            <TextField
              id="outlined-basic"
              label="Colonia de la Ref. fam."
              variant="outlined"
              className="txtDireccionCalle"
              value={currentRow["ColoniaRef"]}
            />
            <TextField
              id="outlined-basic"
              label="Localidad de la Ref. fam."
              variant="outlined"
              className="txtDireccionCalle"
              value={currentRow["LocaliRef"]}
            />
            <TextField
              id="outlined-basic"
              label="Código postal de Ref. Fam"
              variant="outlined"
              className="txtDireccionCalle"
              value={currentRow["CpRef"]}
            />
            <TextField
              id="outlined-basic"
              label="Teléfono de la Ref. Fam. 1"
              variant="outlined"
              className="txtDireccionCalle"
              value={currentRow["TelRef"]}
            />
          </div>
        </Form>
        <div className="modalAdicion__buttoncontainer modalAdicion__buttoncontainerDirecciones">
          <button
            className="modalAdicion__btnCancelar"
            type="button"
            onClick={() => setShow(false)}
          >
            Cancelar
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ModalAdicion;
